import React, { useState, useEffect } from "react";
import "./Menu.scss";
import mbd from "../../../resources/images/svg/martley_full_logo.svg";
import mbdSymbol from "resources/images/svg/martley_symbol.svg";
import { useStateSelector, useActionDispatch } from "./hooks.js";
import { Kebab } from "components/_templates";
import { HashLink as Link } from "react-router-hash-link";
import { MenuRibbon } from "components/_ui";
import { useSpring, animated, config } from "react-spring";
import { Waypoint } from "react-waypoint";
import { useHistory } from "react-router";

const Menu = () => {
  const history = useHistory();
  const path = history.location.pathname;

  const [scrollPosition, setScrollPosition] = useState(true);

  // Scroll watcher to toggle full logo ↔ symbol
  useEffect(() => {
    const onScroll = () => {
      const collapsed = (window.scrollY || window.pageYOffset) > 60;
      setScrollPosition(!collapsed); // true = full logo, false = symbol
    };
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const menuTransition = useSpring({ config: config.gentle });

  const { kebab } = useStateSelector();
  const { handle_kebab } = useActionDispatch();

  const handleClickMenu = () => {
    !kebab ? handle_kebab(true) : handle_kebab(false);
  };

  // Treat BrandKeeper like Home for logo collapse behavior
  const behavesLikeHome = path === "/" || path.startsWith("/brandkeeper");

  const showLogo = () => {
    if (behavesLikeHome) {
      return scrollPosition ? (
        <a href="/" className="menu__logo-link">
          <img src={mbd} alt="Martley Strategy™" />
        </a>
      ) : (
        <a href="/" className="menu__logo-link">
          <img src={mbdSymbol} className="logo-symbol" alt="Martley Strategy™" />
        </a>
      );
    }
    return (
      <a href="/" className="menu__logo-link">
        <img src={mbdSymbol} className="logo-symbol" alt="Martley Strategy™" />
      </a>
    );
  };

  return (
    <>
      <Waypoint
        onEnter={() => setScrollPosition(true)}
        onLeave={() => setScrollPosition(false)}
      />

      {/* Home keeps the ribbon tall/short; other pages keep it hidden */}
      <div className={`menu-bar ${path === "/" ? "full" : "static"}`}>
        {path === "/" && (
          <animated.div style={menuTransition} className={`ribbon ${scrollPosition ? "tall" : "short"}`}>
            <MenuRibbon />
          </animated.div>
        )}

        <div className={`component ${scrollPosition ? "tall" : "short"}`}>
          <div className="inner-wrap">
            {/* Left: brand logo */}
            <div className="logo">{showLogo()}</div>

            {/* Right group: BrandKeeper link + kebab */}
            <div className="menu">
              {path === "/" && (
                <div className="trigger">
                  <Link
                    to="/brandkeeper"
                    className="menu__brandkeeper"
                    aria-label="BrandKeeper landing page"
                  >
                    BrandKeeper<span aria-hidden="true">™</span>
                  </Link>
                </div>
              )}

              <button
                className="burger"
                type="button"
                onClick={handleClickMenu}
                aria-label="Open menu"
              >
                <div className="dot top" />
                <div className="dot mid" />
                <div className="dot bottom" />
              </button>
            </div>
          </div>
        </div>
      </div>

      <Kebab />
    </>
  );
};

export default Menu;
